import React from "react";

import ProjectCard from "../components/ProjectCard";
import HighlightBlock from "../components/HighlightBlock";

import image1 from "../assets/img/urla/1/f1.jpg";
import image2 from "../assets/img/green/gp1.jpg";
import image3 from "../assets/img/karsiyaka/kg1.jpg";
import image4 from "../assets/img/bornova/b1.jpg";
import image5 from "../assets/img/parkbirebir/birebir.jpg";

const complatedProjects = [
    { id: 3, image: image3, title: "Karşıyaka Green", subtitle: "Prestijli Bir Yaşam", link: "/projects/karsiyaka-green" },
    { id: 4, image: image4, title: "Bornova Green", subtitle: "Eğitim ve Eğlence", link: "/projects/bornova-green" },
    { id: 5, image: image5, title: "Park Birebir Hayat", subtitle: "", link: "#" }
];
const projects = [
    { id: 1, image: image1, title: "Urla Green", subtitle: "Doğayla Bütünleşen Yaşam", link: "/projects/urla" },
    { id: 2, image: image2, title: "Green Park", subtitle: "Modern Mimaride Yaşam", link: "/projects/green-park" }
];

export default function ProjectsPage() {
    document.title = "HCP Yapı - Projeler";

    return (
        <section className="py-5 bg-white">
            <div className="container">
                <HighlightBlock bgLabel="Projeler" calligraphy="Satışı Devam Eden" >
                    <div className="row g-1">
                        {projects.map((p) => (
                            <div key={p.id} className="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex pl-2 pr-2">
                                <ProjectCard {...p} />
                            </div>
                        ))}
                    </div>
                </HighlightBlock>
            </div>
            <div className="container">
                <HighlightBlock bgLabel="Projeler" calligraphy="Satışı Tamamlanan" >
                    <div className="row g-1">
                        {complatedProjects.map((p) => (
                            <div key={p.id} className="col-12 col-sm-6 col-lg-4 col-xl-3 d-flex pl-2 pr-2">
                                <ProjectCard {...p} />
                            </div>
                        ))}
                    </div>
                </HighlightBlock>
            </div>
        </section>
    );
}
